import React, { useState, useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";

import Header from "./pages/Header";
import Footer from "./pages/Footer";
import MobileBottomNav from "./components/MobileBottomNav";
import Home from "./pages/Home";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Blogs from "./pages/Blogs";
import BlogDetails from "./pages/BlogDetails";
import AdminDashboard from "./pages/admin/AdminDashboard";
import TermsAndConditions from "./pages/TermsCondtions";

const PublicLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
    <MobileBottomNav />
  </>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    document.body.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
};

const WhatsAppIcon = () => {
  return (
    <a
      href="https://wa.me/918074597649?text=Hi"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "90px",
        right: "20px",
        zIndex: 1001,
        transition: "transform 0.3s ease",
        display: "inline-block",
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
        overflow: "hidden"
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <img 
        src="assets/img/whatsapp.gif" 
        alt="whatsapp" 
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </a>
  );
};

const App = () => {
  return (
    <>
      
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <PublicLayout>
                  <Home />
                </PublicLayout>
              }
            />
            <Route
              path="/about"
              element={
                <PublicLayout>
                  <About />
                </PublicLayout>
              }
            />
            <Route
              path="/blogs"
              element={
                <PublicLayout>
                  <Blogs />
                </PublicLayout>
              }
            />
            <Route
              path="/blogs/:slug"
              element={
                <PublicLayout>
                  <BlogDetails />
                </PublicLayout>
              }
            />
            <Route
              path="/gallery"
              element={
                <PublicLayout>
                  <Gallery />
                </PublicLayout>
              }
            />
            <Route
              path="/contact"
              element={
                <PublicLayout>
                  <Contact />
                </PublicLayout>
              }
            />
            <Route
              path="/terms-and-conditions"
              element={
                <PublicLayout>
                  <TermsAndConditions />
                </PublicLayout>
              }
            />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <WhatsAppIcon />
      
    </>
  );
};
export default App;
